import './product-preview';

jQuery(function ($) {
   // Scrolled Items
   function handleScroll() {
      let $window = $(window);
      let scrollHeight = $window.scrollTop();
      let windowWidth = $window.width();
      let $elements = $(".site-header, .site-branding a svg, .live-search-results");
      let $elementsNoClassBelow1200 = $(".menu-item a");

      $elements.toggleClass('scrolled', scrollHeight > ($elements.first().height() / 4));

      if (windowWidth < 1200) {
         $elementsNoClassBelow1200.removeClass('scrolled');
      }
   }

   let scrollFrame = null;
   function scheduleScroll() {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(function () {
         scrollFrame = null;
         handleScroll();
      });
   }

   document.addEventListener('scroll', scheduleScroll, { passive: true });
   window.addEventListener('resize', scheduleScroll);
   handleScroll();

   // Auto load popup
   $('.nav-close-popup').on('click', function () {
      $(this).closest('.nav-popup-overlay').fadeOut();
   });

   $('.nav-popup-overlay').on('click', function (e) {
      if (e.target === this) {
         $(this).fadeOut(300);
      }
   });

   $(window).on('load', function () {
      if ($('body').hasClass('page-template-front-page')) {
         if (!sessionStorage.getItem('popupShown')) {
            setTimeout(function () {
               $('.nav-popup-overlay--autoload').fadeIn();
               sessionStorage.setItem('popupShown', 'true');
            }, 1000);
         }
      }
   });

   // FAQ Accordion
   const $items = $(".accordion__item");

   $items.on("click", function () {
      const $clicked = $(this);
      const isActive = $clicked.hasClass("active");

      $items.removeClass("active");

      if (!isActive) {
         $clicked.addClass("active");
      }
   });
});

// Ajax logic sticky cart
jQuery(function ($) {
   function shouldShowStickyNow() {
      if (window.matchMedia('(max-width: 767px)').matches) {
         return (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20);
      }
      return true;
   }

   function applyWooFragments(payload) {
      if (!payload || !payload.fragments) return;

      $.each(payload.fragments, function (selector, html) {
         $(selector).replaceWith(html);
      });

      if (payload.cart_hash) {
         try {
            sessionStorage.setItem('wc_cart_hash', payload.cart_hash);
            localStorage.setItem('wc_cart_hash', payload.cart_hash);
         } catch (e) {}
      }

      $(document.body).trigger('wc_fragments_refreshed');
      $(document.body).trigger('updated_wc_div');
   }

   function setStickyQty(newQty) {
      const wrap = $('.sticky-cart');
      if (!wrap.length) return;

      const cartItemKey = wrap.data('cart_item_key');
      const nonce = wrap.data('nonce');

      $.ajax({
         type: 'POST',
         url: wc_add_to_cart_params.ajax_url,
         data: {
            action: 'sticky_cart_set_qty',
            cart_item_key: cartItemKey,
            quantity: newQty,
            nonce: nonce
         },
         success: function (response) {
            if (!response || !response.success) return;

            const data = response.data;

            if (data.removed) {
               wrap.hide();
            } else {
               wrap.find('.sticky-cart__val').text(data.qty);
               wrap.find('.sticky-cart__price').html(data.subtotal);

               if (!shouldShowStickyNow()) wrap.hide();
               else wrap.show();
            }

            applyWooFragments(data);
         }
      });
   }

   $(document).on('click', '.sticky-cart__plus, .sticky-cart__minus', function (e) {
      e.preventDefault();

      const wrap = $(this).closest('.sticky-cart');
      const valEl = wrap.find('.sticky-cart__val');
      const current = parseInt(valEl.text(), 10) || 0;

      let next = current;
      if ($(this).hasClass('sticky-cart__plus')) next = current + 1;
      if ($(this).hasClass('sticky-cart__minus')) next = current - 1;
      if (next < 0) next = 0;

      setStickyQty(next);
   });

   $(document).on('click', '.sticky-cart__close', function (e) {
      e.preventDefault();
      $(this).closest('.sticky-cart').hide();
   });
});

// Counter animations
jQuery(function ($) {
   function animateOnce($el, className) {
      if (!$el || !$el.length) return;

      $el.removeClass(className);
      void $el[0].offsetWidth;
      $el.addClass(className);

      setTimeout(function () {
         $el.removeClass(className);
      }, 600);
   }

   $(document).on("myl:wishlist:updated", function (e, payload) {
      animateOnce($(".js-wishlist-count"), "is-animating-counter");
      if (payload && payload.$btn) animateOnce(payload.$btn, "is-animating-icon");
   });

   $(document.body).on("wc_fragments_refreshed wc_fragments_loaded", function () {
      animateOnce($(".js-cart-count"), "is-animating-counter");
   });

   $(document.body).on("myl:cart:updated", function () {
      setTimeout(function () {
         animateOnce($(".js-cart-count"), "is-animating-counter");
      }, 50);
   });
});

// Products + wishlist tooltips
window.MYL_UI = window.MYL_UI || {};
window.MYL_UI.toast = (function ($) {
   let $wrap;

   function getWrap() {
      if (!$wrap || !$wrap.length) {
         $wrap = $('<div class="myl-toast-wrap" aria-live="polite" aria-atomic="true"></div>');
         $("body").append($wrap);
      }
      return $wrap;
   }

   function show(message, type = "info", options = {}) {
      const settings = $.extend({
         duration: 3500,
         closeExisting: false
      }, options);

      const $container = getWrap();

      if (settings.closeExisting) {
         $container.find(".myl-toast").remove();
      }

      const $toast = $(`
            <div class="myl-toast myl-toast--${type}" role="status">
                <div class="myl-toast__text"></div>
            </div>
        `);

      $toast.find(".myl-toast__text").html(message);
      $container.append($toast);

      requestAnimationFrame(() => {
         $toast.addClass("is-visible");
      });

      const hide = () => {
         $toast.removeClass("is-visible").addClass("is-hiding");
         setTimeout(() => {
            $toast.remove();

            if (!$container.children().length) {
               $container.remove();
               $wrap = null;
            }
         }, 250);
      };

      setTimeout(hide, settings.duration);

      return {
         hide,
         element: $toast
      };
   }

   return {
      show
   };
})(jQuery);

jQuery(function ($) {
   $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
      let productName = '';

      if ($button && $button.length) {
         productName = $button.closest('.product-card').find('.product-card__title').text().trim();
      }

      MYL_UI.toast.show(
         productName
            ? `<p class="myl-toast__product">„${productName}”</p> è stato aggiunto al carrello.`
            : "Il prodotto è stato aggiunto al carrello.",
         "success",
         { duration: 3500 }
      );
   });
});

// Data Layer for GTM/GA4
jQuery(function ($) {
   var pageType = null;

   if ($('body').hasClass('home') || $('body').hasClass('front-page')) {
      pageType = 'home';
   } else if ($('body').hasClass('tax-product_cat')) {
      pageType = 'category';
   }

   if (pageType) {
      $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
            event: 'add_to_cart',
            page_type: pageType,
            product_id: $button.data('product_id'),
            product_sku: $button.data('product_sku'),
            quantity: $button.data('quantity')
         });
      });
   }
});
